function getRandomIndex(length) {
  return Math.floor(Math.random() * length);
}

function getTwoDifferentRandomIndices(length) {
  if (length <= 1) return [0];

  const first = getRandomIndex(length);
  let second;

  do {
    second = getRandomIndex(length);
  } while (second === first);

  return [first, second];
}

document.addEventListener("DOMContentLoaded", () => {
  // -----------------------------
  // Media Grids: 2 zufällige anzeigen
  // -----------------------------
  const mediaGrids = document.querySelectorAll(
    ".shopify-section.shopify-section--media-grid"
  );

  if (mediaGrids.length >= 2) {
    const [firstIndex, secondIndex] = getTwoDifferentRandomIndices(mediaGrids.length);

    mediaGrids[firstIndex].style.display = "block";
    mediaGrids[secondIndex].style.display = "block";
  } else if (mediaGrids.length === 1) {
    mediaGrids[0].style.display = "block";
  }

  // -----------------------------
  // Slideshows: Desktop & Mobile getrennt
  // 0–1 = Desktop | 2–4 = Mobile
  // -----------------------------
  const slideshows = Array.from(
    document.querySelectorAll(".shopify-section--slideshow.container")
  );

  if (slideshows.length < 3) return;

  const desktopSlideshows = slideshows.slice(0, 2);
  const mobileSlideshows = slideshows.slice(2); // alles ab Index 2 = Mobile

  // Klassen setzen
  desktopSlideshows.forEach((el) => {
    el.classList.add("is_desktop");
    el.classList.remove("is_mobile", "show_me");
  });

  mobileSlideshows.forEach((el) => {
    el.classList.add("is_mobile");
    el.classList.remove("is_desktop", "show_me");
  });

  // Random Auswahl
  if (desktopSlideshows.length > 0) {
    const desktopIndex = getRandomIndex(desktopSlideshows.length);
    desktopSlideshows[desktopIndex].classList.add("show_me");
  }

  if (mobileSlideshows.length > 0) {
    const mobileIndex = getRandomIndex(mobileSlideshows.length);
    mobileSlideshows[mobileIndex].classList.add("show_me");
  }
});